// extracted by mini-css-extract-plugin
export var bodySections = "_87-8";
export var gray = "_87-7";
export var green = "_87-4";
export var iconContainer = "_87-9";
export var iconWidgetContainer = "_87-1";
export var phoneIcon = "_87-2";
export var red = "_87-5";
export var statusDot = "_87-3";
export var widgetContainer = "_87-0";
export var yellow = "_87-6";